import { Type } from "@themes/pollinator/ui/Type";
import { ProgramPhase } from "@core/features/program";
import type { Article } from "@core/features/support";
import { MeetingRole } from "@platform/types/platform.types";
import { SupportArticleList } from "@platform/features/support";
import { ProgramPhaseActionList } from "../../PhaseAction";
import { ProgramMeetingRoleBadge } from "@platform/features/programScheduling";
import Button from "@themes/pollinator/ui/Button";

export type Props = {
  phase: ProgramPhase;
  isLoading: boolean;
  role: MeetingRole | null;
  isPhaseInScheduledEngagement: boolean;
  hasMeeting: boolean;
  onMeetingInformationClick: () => void;
  onOpenArticle: (article: Article) => void;
};

export function ProgramPhaseItem({
  phase,
  isLoading,
  role,
  isPhaseInScheduledEngagement,
  hasMeeting,
  onMeetingInformationClick,
  onOpenArticle,
}: Props) {
  return (
    <div className="flex flex-col gap-6 min-w-full">
      <div className="flex flex-col gap-1">
        <Type variant="h4">{phase.name}</Type>
        <Type variant="body2" className="max-w-xl">
          {phase.description}
        </Type>
        <div className="flex flex-col gap-2 md:flex-row ">
          {role && (
            <div className="flex flex-row gap-0.5">
              <Type variant="body2">Your role this week:</Type>
              <ProgramMeetingRoleBadge role={role} badgeClassName="ml-1" />
            </div>
          )}
          {isPhaseInScheduledEngagement && hasMeeting && (
            <Button
              variant="link-inline"
              className="px-0 inline-block underline"
              typeVariant="body2"
              onClick={onMeetingInformationClick}
            >
              All roles for this week.
            </Button>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <ProgramPhaseActionList
          actions={phase.actions ?? []}
          isLoading={isLoading}
        />

        {(phase.resources?.articles?.length ?? 0) > 0 && (
          <div className="flex flex-col border border-brand-800 rounded-lg gap-4 py-6 md:p-6">
            <SupportArticleList
              title="Related FAQs"
              articles={phase.resources?.articles ?? []}
              onOpenArticle={onOpenArticle}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProgramPhaseItem;

